module.exports = __webpack_public_path__ + "static/media/delivery.72ac1083.svg";